import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgswManifest } from './ngsw-manifest';

@Injectable({ providedIn: 'root' })
export class NgswService {
  constructor(private http: HttpClient) {}

  public getManifest(deployUrl: string): Promise<NgswManifest> {
    return this.http
      .get<NgswManifest>(`${deployUrl}/ngsw.json`, {
        responseType: 'json',
      })
      .toPromise();
  }
}
